/** App-wide constants. Mirrors the mockup's CONFIG.SHELL. */
export const SHELL = {
  brandInitial: "S",
  product: "SpectaShield",
  company: "Pinnacle Digital Analytics Pvt. Ltd.",
  year: 2026,
  version: "v2.0.0",
  defaultTitle: "Platform Console",
} as const;
